import React from 'react';

import Badge from '@adsk/alloy-react-badge';
import { useLocale } from '@adsk/alloy-react-locale';

import { REVIEW_STATE, IN_PROGRESS_STEP } from '../../consts';
import { useStatus } from '../../hooks';
import { ItemState, SubmittalsItem } from '../../types';
import { getStepNumber } from '../../utils/steps';

interface StateCellProps {
  stateId: ItemState;
  itemData: SubmittalsItem;
}

const StatusCell: React.FC<StateCellProps> = ({ stateId, itemData }) => {
  const { T } = useLocale(({ locale }) => require(`../../i18n/${locale}.json`));
  const isItemInReview = stateId === REVIEW_STATE;
  const totalSteps = itemData.steps.length;
  const inProgressStep = itemData.steps.find((step) => {
    if (step.status === IN_PROGRESS_STEP) return step.stepNumber;
    return 0;
  });
  const currentStep = inProgressStep?.stepNumber || 0;
  const { stateText, statusText, color } = useStatus(stateId);
  const reviewStateText = ` ${stateText} | ${T.translate(
    'STEP',
  )} ${getStepNumber(currentStep)}/${getStepNumber(totalSteps)}`;

  const subStatusText =
    isItemInReview && totalSteps > 0 ? reviewStateText : stateText;
  return (
    <>
      <Badge
        stacked
        style={{ padding: 0 }}
        variant={Badge.VARIANTS.LINE}
        subStatus={subStatusText}
        color={color}
      >
        {statusText}
      </Badge>
    </>
  );
};

StatusCell.displayName = 'SubmittalsStatusCell';

export default StatusCell;
